import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { getApiUserReady } from '@/stores/slices/userSlice';
import useLadyService from '@/services/LadyService';
import { Authorization } from '../popups';
import { Loader } from '../ui';
import { Suspense } from 'react';

const routeRoles = {
	'/login': ['admin'],
	'/preview': ['admin', 'moderator'],
	'/lk/create': ['indi', 'agency', 'admin', 'moderator'],
	'/lk/customer': ['customer', 'admin'],
	'/lk/agency': ['agency', 'admin'],
	'/lk/parties': ['agency', 'admin'],
	'/lk/indi': ['indi', 'admin', 'moderator'],
	'/lk/topup': ['indi', 'customer', 'agency', 'admin'],
	'/lk/balance': ['indi', 'customer', 'agency', 'admin'],
	'/lk/withdraw': ['indi', 'customer', 'agency', 'admin'],
	'/lk/operators': ['agency', 'admin'],
	'/lk/profiles': ['indi', 'agency', 'admin', 'moderator'],
	'/lk/videochats': ['indi', 'agency', 'admin'],
	'/lk/reservations': ['indi', 'agency', 'admin'],
	'/lk/reviews': ['indi', 'agency', 'admin'],
	'/lk/previews': ['indi', 'agency', 'admin'],
	'/lk/statistic': ['indi', 'agency', 'admin'],
	'/lk/profile': ['indi', 'agency', 'admin'],
	'/lk/support': ['indi', 'agency', 'admin', 'customer'],
	'/lk/changeparty': ['agency', 'admin'],
	'/lk/party': ['indi', 'customer', 'agency', 'admin'],
};
function PrivateRoute({ children }) {
	const { userType, token } = useLadyService();
	const navigate = useNavigate();

	const apiReady = useSelector(getApiUserReady);

	const location = useLocation();
	const currentPath = location.pathname;

	// ── 1. Not logged in at all ──────────────────────────────────────────────
	if (!token) {
		// Show auth popup, render nothing → lazy chunk never downloads
		return (
			<>
				<Authorization forceOpen />
			</>
		);
	}

	// ── 2. Token exists but /me hasn't resolved yet ──────────────────────────
	if (!apiReady) {
		// Spinner while we wait for userType from API
		return <Loader height={100} />;
	}

	// ── 3. API ready - check role access ────────────────────────────────────
	const isAuthorized = Object.keys(routeRoles).some((route) => {
		if (currentPath.includes(route)) {
			return routeRoles[route].includes(userType);
		}
		return false;
	});

	if (!isAuthorized) {
		navigate('/');
		return null;
	}

	// ── 4. Authorized - now it's safe to render (and download) lazy chunk ───
	return (
		<Suspense fallback={<Loader height={100} />}>
			{children}
			<Authorization />
		</Suspense>
	);
}

export default PrivateRoute;
